import React from 'react';
import { RouteComponentProps } from '@reach/router';
import FullPage from '../../../layouts/FullPage';
import { nanoid } from 'nanoid';

// TODO: Import components

interface IDesignerProductivityReportPageProps extends RouteComponentProps { }

interface IState { }

class DesignerProductivityReportPage extends React.Component<IDesignerProductivityReportPageProps, IState> {
    // Define the constructor for the designer productivity report page
    constructor (props: IDesignerProductivityReportPageProps) {
        // Pull in parent props
        super(props);
    }

    // TODO: When the component mounts
    componentDidMount () {
    }

    // Render the TSX for the designer productivity report container
    render () {
        return (
            <FullPage>
                <section className="section" style={{ paddingTop: '1rem' }}>
                    <div className="container">
                        <nav className="navbar navbar-expand-lg navbar-dark flex-column shadow-2 bg-white">
                            <div className="container d-stick-none">
                                <div className="navbar-left">
                                    <button className="navbar-toggler" type="button"><span className="navbar-toggler-icon"></span></button>
                                    <span className="nav-link fw-600">Designer Productivity Report for Employee Name</span>
                                </div>

                                <section className="navbar-mobile">
                                    <nav className="nav nav-navbar ml-auto">
                                        <span className="nav-link">
                                            <span className="badge badge-secondary mr-1">Day</span>
                                            <span className="badge badge-primary mr-1">Week</span>
                                            <span className="badge badge-secondary mr-1">Month</span>
                                            <span className="badge badge-secondary mr-1">Quarter</span>
                                            <span className="badge badge-secondary mr-1">Year</span>
                                            <span className="badge badge-secondary mr-1">All Time</span>
                                        </span>
                                    </nav>
                                </section>
                            </div>
                        </nav>
                    </div>
                </section>

                <section className="section" style={{ paddingTop: '0rem' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-10 mx-auto">
                                {/* TODO: Add functionality and remove warning */}
                                <div className="alert alert-warning" role="alert">Designer Productivity report is not yet functional</div>

                                <div className="border rounded shadow-2 p-4 mb-4 bg-white" key={nanoid()}>
                                    <div className="row">
                                        <div className="col lh-5">
                                            <div className="row">
                                                <div className="col lh-5">
                                                    <div className="row">
                                                        <div className="col-6 lh-5"><strong>Client</strong></div>
                                                        <div className="col-2 text-left"><strong>Est Hours</strong></div>
                                                        <div className="col-2 text-left"><strong>Hours</strong></div>
                                                        <div className="col-2 text-left"><strong>Diff Hours</strong></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-6 lh-5">Auburn-Opelika Tourism Bureau</div>
                                                <div className="col-2 text-left">5.00</div>
                                                <div className="col-2 text-left">7.00</div>
                                                <div className="col-2 text-left">2.00</div>
                                            </div>

                                            <div className="row">
                                                <div className="col-6 lh-5">Boulder City</div>
                                                <div className="col-2 text-left">3.50</div>
                                                <div className="col-2 text-left">3.25</div>
                                                <div className="col-2 text-left">0.25</div>
                                            </div>

                                            <div className="row">
                                                <div className="col-6 lh-5">Citrus County</div>
                                                <div className="col-2 text-left">55.00</div>
                                                <div className="col-2 text-left">59.00</div>
                                                <div className="col-2 text-left">4.00</div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12 lh-5">&nbsp;</div>
                                            </div>

                                            <div className="row">
                                                <div className="col-6 lh-5"><strong>Total</strong></div>
                                                <div className="col-2 text-left"><strong>130.00</strong></div>
                                                <div className="col-2 text-left"><strong>115.55</strong></div>
                                                <div className="col-2 text-left"><strong>6.25</strong></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*
                            [x] Date of Report
                            [x] Designer Name
                            [-] Hours For The Week (40) / Month / Qtr / Yr
                            [-] Projects Assigned For The Week
                            [-] Hours Assigned To Each Milestone For Each Project and Summarized For all projects
                            [-] Forecasted Hours For The Project and Summarized total
                            [-] Actual Hours For The Project and Summarized Total
                            [-] Variance Hours for the project and summarized by total
                        */}
                    </div>
                </section>
            </FullPage>
        );
    }
}

export default DesignerProductivityReportPage;
